import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from './core/authenticated.guard';
import { NotAuthenticatedGuard } from './core/not-authenticated.guard';
import { AuthorizedGuard } from './core/authorized.guard';
import { ExpiredGuard } from './core/expired.guard';

import { PageNotFoundComponent } from './core/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: 'app/modules/dashboard/dashboard.module#DashboardModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'settings',
    loadChildren: 'app/modules/settings/settings.module#SettingsModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'NTLAnalytics',
    loadChildren:
      'app/modules/ntl-analytics/ntl-analytics.module#NtlAnalyticsModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'NTLInspections',
    loadChildren:
      'app/modules/ntl-selection/ntl-selection.module#NtlSelectionModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'contractNTLInspections',
    loadChildren:
      'app/modules/contract-ntl-selection/contract-ntl-selection.module#ContractNtlSelectionModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'marketplace',
    loadChildren:
      'app/modules/marketplace/marketplace.module#MarketplaceModule',
    canLoad: [AuthenticatedGuard],
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'userpreferences',
    loadChildren:
      'app/modules/user-preferences/user-preferences.module#UserPreferencesModule',
    canLoad: [AuthenticatedGuard],
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'users',
    loadChildren: 'app/modules/users/users.module#UsersModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'knowledgeBasePatterns',
    loadChildren:
      'app/modules/knowledge-base/knowledge-base.module#KnowledgeBaseModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'customerAnalysis',
    loadChildren:
      'app/modules/consumer-analysis/consumer-analysis.module#ConsumerAnalysisModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'customerDetails/:id',
    loadChildren:
      'app/modules/consumer-analysis/consumer-analysis.module#ConsumerAnalysisModule',
    canLoad: [NotAuthenticatedGuard],
    canActivate: [NotAuthenticatedGuard],
  },
  {
    path: 'contractAnalysis',
    loadChildren:
      'app/modules/contract-analysis/contract-analysis.module#ContractAnalysisModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'externalPatterns',
    loadChildren:
      'app/modules/external-patterns/external-patterns.module#ExternalPatternsModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'channels',
    loadChildren:
      'app/modules/channels/channels.module#ChannelsModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'dataQuality',
    loadChildren:
      'app/modules/data-quality/data-quality.module#DataQualityModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'login',
    loadChildren: 'app/modules/login/login.module#LoginModule',
    canLoad: [NotAuthenticatedGuard],
  },
  {
    path: 'loginExternal',
    loadChildren: 'app/modules/login-external/login-external.module#LoginExternalModule',
    canLoad: [NotAuthenticatedGuard],
  },
  {
    path: 'loginReset',
    loadChildren: 'app/modules/login-reset/login-reset.module#LoginResetModule',
    canLoad: [NotAuthenticatedGuard],
  },
  {
    path: 'loginExpired',
    loadChildren:
      'app/modules/login-expired/login-expired.module#LoginExpiredModule',
    canLoad: [ExpiredGuard],
  },
  {
    path: 'v4Integration',
    loadChildren:
      'app/modules/v4-integration/v4-integration.module#V4IntegrationModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'topos',
    loadChildren: 'app/modules/v4-topos/v4-topos.module#V4ToposModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'mobile',
    loadChildren: 'app/modules/mobile-ri/mobile-ri.module#MobileRiModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'backoffice',
    loadChildren: 'app/modules/backoffice/backoffice.module#BackofficeModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  {
    path: 'geodisconnection',
    loadChildren: 'app/modules/geodisconnection/geodisconnection.module#GeodisconnectionModule',
    canLoad: [AuthorizedGuard],
    canActivate: [AuthorizedGuard],
  },
  { path: '', redirectTo: 'marketplace', pathMatch: 'full' },
  {
    path: '**',
    component: PageNotFoundComponent,
    pathMatch: 'full',
    canActivate: [AuthenticatedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts